import { LinkExternal, LinkRouter, LinkWithAnchor } from './components';
import { getPathname, isExternalUrl, parseTargetLocation } from './helpers';
import type { LinkProps } from './@types';

const LinkBase = ({ children, exact, isactive, onClick = () => ({}), to, ...props }: LinkProps) => {
  const target = parseTargetLocation(to);
  const { hash } = target;
  if (isExternalUrl(to)) {
    return (
      <LinkExternal onClick={onClick} pathname={getPathname(to)} {...props}>
        {children}
      </LinkExternal>
    );
  }

  if (hash) {
    return (
      <LinkWithAnchor onClick={onClick} pathname={hash} {...props}>
        {children}
      </LinkWithAnchor>
    );
  }

  return (
    <LinkRouter exact={exact} isactive={isactive} onClick={onClick} to={target} {...props}>
      {children}
    </LinkRouter>
  );
};

export default LinkBase;
